<router-outlet></router-outlet>

<div class="tw-flex tw-flex-wrap tw-gap-4 tw-mt-4">
  <div class="tw-w-full">
    @if (!homepage) {
      <a bitButton routerLink="./">
        {{ "backToReports" | i18n }}
      </a>
    }
  </div>
</div>
